<template>
	<header class="zui-header" :class="{headerActive:headerActive,borderGrey:borderGrey}">
		<!-- <logo type="xiaoyanyun" href="/"></logo> -->
		<div class="zui-logo" @click="onClick"></div>
		<p class="zui-logo-text">
			享誉全球的世界重要 <br>旅游目的地
		</p>
		<!--<p class="zui-logo-text">
			<img :src="iconUrl" alt="" v-show="iconUrl != ''" class="temp-icon">
			<span>{{ temp }}</span>
		</p>-->
		<!--获取栏目列表，顶级栏目默认可以不传，这里获取的是顶级栏目，如果是其他栏目需要指定pid-->
		<!--tag参数表示cms-article组件最终在页面上渲染出的元素-->
		<cms-column-list pid="1" tag="span" id="menus">
			<template slot-scope="scope">
				<el-dropdown class="zui-button" style="" v-for="item in scope.list" :key="item.id" placement="bottom-start">
					<span class="el-dropdown-link zui-button zui-top" @click="onButtonClick(item.route,item)">
						{{ item.name }}
					</span>
					<el-dropdown-menu class="dropdown-menu zui-dropdown" slot="dropdown">
						<el-dropdown-item class="zui-button"
										  :class="(currentPath === item.route && currentPoint === item_.id) ? 'active' : ''"
										  v-for="(item_, index) in menus[item.id]" :key="item_.id">
							<span class="el-dropdown-link" @click="onSubClick(item.route, item_)">
								{{ item_.name }}
							</span>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</template>
		</cms-column-list>
		<div class="zui-right-btn">
			<!--<p id="oldText">本网站为峨眉山旅游网测试版</p>-->
			<!--<div id="oldLink" class="oldAddress"><a href="http://www.ems517.com/old" target="_blank">前往原网站</a></div>-->
			<div class="changeLang">
				<el-dropdown trigger="click" @command="onButtonClick">
					<span class="el-dropdown-link zui-rightcol">
						中<i class="el-icon-caret-bottom el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item @click="goEnglish()" command="/englishIndex">英</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
			<div class="zui-search" @click="openSearch"></div>
		</div>
		<cms-column-list pid="1" tag="span" id="nav">
			<template slot-scope="scope">
					<span class="zui-rightcol" @click="isShowMenus = true" v-if="!isShowMenus">
						<i class="el-icon-s-fold el-icon--right"></i>
					</span>
					<span class="zui-rightcol" @click="isShowMenus = false" v-else>
						<i class="el-icon-s-unfold el-icon--right"></i>
					</span>
				<div class="mm_out" :class="isShowMenus ? 'height_100' : ''">
					<div class="mobile_menus" v-for="item in scope.list" :key="item.id" v-if="isShowMenus">
						<div class="one_menu" @click="onButtonClick(item.route,item)">
							<span>{{ item.name }}</span>
							<i class="el-icon-arrow-right"></i>
						</div>
						<div class="mm_sub_out">
							<div class="mm_sub" v-for="(item_, index) in menus[item.id]" :key="item_.id" @click="onSubClick(item.route, item_)">
								{{ item_.name }}
							</div>
						</div>
					</div>
					<div class="close_mm" v-if="isShowMenus">
						<i class="el-icon-circle-close" @click="isShowMenus = false"></i>
					</div>
				</div>

				<!--<el-dropdown trigger="click" @command="onButtonClick">
					<span class="el-dropdown-link zui-rightcol">
						<i class="el-icon-s-unfold el-icon&#45;&#45;right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="item in scope.list" :key="item.id"
							:command="item.route">{{ item.name }}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>-->
			</template>
		</cms-column-list>
		<NcNav :navConfigList="navConfigList" :wenjuan="wenjuan" ref="ncNav" v-if="navConfigList.length > 0"
			   @side-click="sideClick" />
	</header>
</template>
<script>
	import moment from 'moment';
	import './less/header.css'
	import ZuiButton from '../components/Button'
	import NcNav from '../components/template/NcNav.vue'
	import Logo from './Logo'
	import axios from "axios";
	import Util from '../Util'
	import {postMgrApiVisitItem,postVisitUnique} from "~/api/CmsApi";
	export default {
		components: {
			ZuiButton,
			Logo,
			NcNav
		},
		props: {
			logoType: {
				default: 'zhichou'
			},
			headerActive: {
				type: Boolean,
				default: false
			},
			borderGrey: {
				type: Boolean,
				default: false
			},
			headerIndex: {
				type: Number,
				default: 0
			},
			navConfigList: {
				type: Array,
				default: function () {
					return []
				}
			},
			wenjuan: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				time: moment().format('YYYY年MM月DD日'),
				temp: '-',
				iconUrl: '',
				context: '/new',
				currentPath: '',
				currentPoint: '',
				isShowMenus:false,
				menus: {
					3: [
						{ name: '景区简介', id: 'one', route: '/link/detail?t=jianjie' },
						{ name: '标志景点', id: 'two', route: '/link/jingdian' },
						{ name: '精彩体验', id: 'three', route: '/link/enjoy' },
						// { name: '双遗产', id: 'four', route: '/link/culture?id=19&tabId=44' },
						// { name: '美景赏析', id: 'five', route: '/link/pictures' },
						{ name: '文化遗产', id: 'four', route: '/link/culture?id=19&tabId=44' },
						{ name: '自然遗产', id: 'five', route: '/link/nature?id=20&tabId=48' },
						{ name: '景区图库', id: 'six', route: '/link/pictureList' },
						{ name: '精彩视频', id: 'seven', route: '/link/videos?id=666' },
					],
					4: [
						{ name: '吃得巴适', id: 'one', route: '/plan/delicious' },
						{ name: '住得舒适', id: 'two', route: '/plan/stay' },
						{ name: '玩得安逸', id: 'three', route: '/plan/happy' },
						{ name: '购得开心', id: 'four', route: '/plan/shopping' },
						{ name: '节庆节日', id: 'five', route: '/plan/activity' },
					],
					5: [
						{ name: '经典路线', id: 'one', route: '/service/route' },
						{ name: '主题产品', id: 'two', route: '/service/production' },
						{ name: '达人攻略', id: 'three', route: '/service/strategy' },
						{ name: '大峨眉旅游度假区', id: 'four' }
					],
					6: [
						{ name: '游客须知', id: 'one' },
						{ name: '活动资讯', id: 'two', route: '/visitor/activity' },
						{ name: '票价信息', id: 'three' },
						{ name: '景区交通', id: 'four' },
						// { name: '余票数据', id: 'five' },
					]
				}
			}
		},
		mounted() {
			let ivue = this;
			this.getWeather();
			this.$nextTick(function () {
				ivue.currentPath = window.location.pathname.replace(ivue.context, '');
				ivue.currentPoint = ivue.$route.query.point;
				if (ivue.currentPoint) {
					var index = ['one', 'two', 'three', 'four', 'five'].indexOf(ivue.currentPoint);
					setTimeout(function () {
						ivue.$refs.ncNav.handleNavItemClick({ id: ivue.currentPoint }, index);
					}, 500);
				}
			});
			this.ifPC()
		},
		methods: {
			openSearch() {
				this.$openNewWindow( this.context + '/search');
				this.getVisits("搜索")
			},
			goEnglish() {
				console.log(111)
			},
			openMenu: function () {
				this.$refs.droplist.show()
			},
			onButtonClick: function (path,item) {
				let ivue = this;
				let name = item.name
				if(name){
					ivue.getVisits(name)
				}
				if (window.location.pathname !== ivue.context + path)
					this.$openNewWindow(ivue.context + path);
			},

			onSubClick: function (path, item) {
				let ivue = this;
				let name = item.name
				ivue.getVisits(name)
				if (item.route)
					this.$openNewWindow({
						path: ivue.context + item.route
					});
				else if (window.location.pathname !== ivue.context + path)
					this.$openNewWindow({
						path: ivue.context + path + '?point=' + item.id
					});
				else {
					var index = ['one', 'two', 'three', 'four', 'five'].indexOf(item.id);
					this.currentPoint = item.id;
					this.$refs.ncNav.handleNavItemClick(item, index);
				}
        this.isShowMenus = false
			},
			onClick: function (e) {
				location.assign('/')
			},
			getWeather() {
				axios.get('https://zylsweather.lintrondata.com/weatherkit/weatherjson/emeishan').then(res => {
					if (res.data.resultcode == 0) {
						// 现在温度
						this.temp = res.data.weatherJson.today.cur_temp;
						// 天气线型图标站内地址
						this.iconUrl = res.data.weatherJson.today.iconsitetianqi2;
					}
				});
			},
			sideClick(id) {
				let ivue = this;
				console.log(id);
				ivue.currentPoint = id;
			},
			//访问量
			getVisits(name) {
				const param = { itemCateName:name };
				postMgrApiVisitItem(param).then(res => {
					if (res.code === 0) {

					} else {

					}

				})
			},
			//判断移动端、pc端
			ifPC(){
				let ifpc = (Util.os().android || Util.os().iPhone) ? 'mobile' : 'pc'
				this.getVisitsUnique(ifpc,"chinese")
				// console.log(ifpc)
			},
			//独立ip访问量
			getVisitsUnique(ifpc,name) {
				const param = { endType:ifpc,languageType: name};
				postVisitUnique(param).then(res => {
					if (res.code === 0) {

					} else {

					}

				})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue